<template>
  <div class="app-root">
    <nav class="app-nav" aria-label="Demo pages">
      <a
        href="#/micro"
        class="app-nav__link"
        :class="{ 'app-nav__link--active': view === 'micro' }"
        @click.prevent="setView('micro')"
      >
        Micro HITL
      </a>
      <a
        href="#/full"
        class="app-nav__link"
        :class="{ 'app-nav__link--active': view === 'full' }"
        @click.prevent="setView('full')"
      >
        Full HITL embed
      </a>
    </nav>
    <MicroHitlDemo v-if="view === 'micro'" />
    <HitlFullEmbedDemo v-else />
  </div>
</template>

<script>
import MicroHitlDemo from './components/MicroHitlDemo.vue';
import HitlFullEmbedDemo from './components/HitlFullEmbedDemo.vue';

function viewFromHash() {
  const hash = (window.location.hash || '').replace(/^#\/?/, '');
  if (hash === 'full' || hash === 'iframe') return 'full';
  return 'micro';
}

export default {
  name: 'App',
  components: { MicroHitlDemo, HitlFullEmbedDemo },
  data() {
    return {
      view: viewFromHash(),
    };
  },
  mounted() {
    window.addEventListener('hashchange', this.onHashChange);
    if (!window.location.hash) {
      window.location.hash = '#/micro';
    }
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
  methods: {
    onHashChange() {
      this.view = viewFromHash();
    },
    setView(view) {
      const hash = view === 'full' ? '#/full' : '#/micro';
      window.location.hash = hash;
      this.view = view;
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
}

#app {
  display: flex;
  flex-grow: 1;
  width: 100%;
  height: 100%;

  .app-root {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    width: 100%;
  }
}

.app-nav {
  flex-shrink: 0;
  display: flex;
  gap: 4px;
  padding: 10px 20px;
  border-bottom: 1px solid #d8e0ea;
  background: #fff;

  &__link {
    padding: 8px 14px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    color: #475569;
    text-decoration: none;

    &:hover {
      background: #f1f5f9;
      color: #1e293b;
    }

    &--active {
      background: #e3f2fd;
      color: #1565c0;
    }
  }
}
</style>
